import 'custom-event-polyfill';
import createStore from 'fluxible/addons/createStore';
import uniqBy from 'lodash.uniqby';
import flatten from 'lodash.flatten';

export default createStore({
    storeName: 'DesignCollectionStore',

    handlers: {
        SET_DESIGN_COLLECTION: 'setDesignCollection',
        UPDATE_DESIGN_START: 'startUpdateDesign',
        UPDATE_DESIGN_FAILED: 'revertUpdateDesign',
        UPDATE_DESIGN_SUCCESS: 'updateDesign',
        UPDATE_DESIGN_COLLECTION_PAGE_DATA_APPEND: 'appendDesignData',
        UPDATE_DESIGN_COLLECTION_PAGE_DATA_PREPEND: 'prependDesignData',
        LOAD_DESIGN_SUCCESS: 'reloadDesignData',
        SET_DESIGN_DATA: 'reloadDesignData',
    },

    initialize: function() {
        this.designs = [];
        this.totalDesignCount = null;
        this.designOffset = null;
        this.isLoading = true;
        this.designPageUrls = [];

        this.prevPageUrl = null;
        this.nextPageUrl = null;
    },

    // public API methods

    setModel: function(model) {
        this.model = model;
    },

    getModel: function() {
        return this.model;
    },

    setCollectionModel: function(collectionModel) {
        this.collectionModel = collectionModel;
    },

    getCollectionModel: function() {
        return this.collectionModel;
    },

    getCurrentPage: function(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return index + this.designOffset + 1;
    },

    getDesign: function(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return this.getDesignByIndex(index);
    },

    getPreviousDesign: function(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return this.getDesignByIndex(index - 1);
    },

    getNextDesign: function(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return this.getDesignByIndex(index + 1);
    },

    // handler methods

    setDesignCollection: function(designCollection) {
        this.initialize();
        this.designs = designCollection.designs;
        this.designPageUrls = designCollection.designPageUrls;
        this.totalDesignCount = designCollection.totalDesignCount;
        this.designOffset = designCollection.designPageOffset;

        if (this.designPageUrls && this.designPageUrls.length > 1) {
            const currentPageIndex = this.designPageUrls.indexOf(designCollection.currentPageUrl);
            this.prevPageUrl = this.designPageUrls[currentPageIndex - 1];
            this.nextPageUrl = this.designPageUrls[currentPageIndex + 1];
        }

        this.emitChange();
    },

    reloadDesignData: function(design) {
        const index = this.getDesignIndexByDesignId(design.designId);
        if (index) {
            this.designs[index] = design;
            this.emitChange();
        }
        window.dispatchEvent(new CustomEvent('ddoDidLoadDesign', { detail: { design } }));
    },

    appendDesignData: function(data) {
        // append the new data to the old data and de-dupe based on file id (self url)
        this.designs = uniqBy(flatten([this.designs, data.designs]), function(design) {
            return design.designId;
        });

        this.updateNextPageUrl(data.pageUrl);
        this.emitChange();
    },

    prependDesignData: function(data) {
        // prepend the new data to the old data and de-dupe based on designId
        let designCount = this.designs.length;
        this.designs = uniqBy(flatten([data.designs, this.designs]), function(design) {
            return design.designId;
        });
        const newlyAddedDesignsCount = this.designs.length - designCount;
        this.designOffset = this.designOffset - newlyAddedDesignsCount;

        this.updatePrevPageUrl(data.pageUrl);
        this.emitChange();
    },

    startUpdateDesign: function(data) {
        const updatedDesign = { ...data.design, ...data.data };
        this.emitChangeForUpdatedDesign(updatedDesign);
    },

    revertUpdateDesign: function(data) {
        const updatedDesign = { ...data.design };
        this.emitChangeForUpdatedDesign(updatedDesign);
    },

    updateDesign: function(design) {
        this.emitChangeForUpdatedDesign(design);

        // hook into flightjs to refresh underlying page
        const event = new window.CustomEvent('uiDesignDetailsOverlayDesignUpdated', {
            bubbles: true,
        });
        document.querySelector('html').dispatchEvent(event);
    },

    // private methods

    getDesignByIndex: function(index) {
        return this.designs[index] || null;
    },

    emitChangeForUpdatedDesign: function(design) {
        var designIndexToUpdate = this.getDesignIndexByDesignId(design.designId);
        var designToUpdate = this.designs[designIndexToUpdate];

        if (designToUpdate) {
            this.designs[designIndexToUpdate] = { ...designToUpdate, ...design };
        }

        this.emitChange();
    },

    getDesignIndexByDesignId: function(designId) {
        return this.designs.findIndex(design => {
            return design && design.designId === parseInt(designId, 10);
        });
    },

    updatePrevPageUrl: function(loadedPageUrl) {
        if (this.prevPageUrl === loadedPageUrl) {
            // navigating backward
            const prevPageIndex = this.designPageUrls.indexOf(this.prevPageUrl) - 1;
            this.prevPageUrl = this.designPageUrls[prevPageIndex];
        }
    },

    updateNextPageUrl: function(loadedPageUrl) {
        if (this.nextPageUrl === loadedPageUrl) {
            // navigating forward
            const nextPageIndex = this.designPageUrls.indexOf(this.nextPageUrl) + 1;
            this.nextPageUrl = this.designPageUrls[nextPageIndex];
        }
    },
});



// WEBPACK FOOTER //
// ./~/@99designs/ddo/stores/DesignCollectionStore.js